
export * from '../../frontend-js-dependencies-web/__liferay__/exports/moment.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/moment.js';
export default __default__;
